import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"transparent ma-0 pa-0",attrs:{"elevation":"0"}},[_c(VCardText,{staticClass:"ma-0 pa-0"},[_c(VRow,_vm._l((_vm.filteredNavItems),function(item){return _c(VCol,{key:((item.key) + "-dashboard"),attrs:{"cols":"12","xs":"6","sm":"6","md":"4","lg":"4","xl":"4"}},[_c('TheDashboardNavigationItem',{attrs:{"payload":item,"is-active":_vm.isActiveNavItem(item.to)}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }